/**
 * A number against the period before, in words. Always where it came from ("up from $25.00 the 7 days
 * before"), never a percentage: a percentage of almost nothing ("+39467%") tells nobody anything.
 */
export type CompareTone = 'success' | 'danger' | 'muted';

export interface Compared {
  /** "up from 12", "down from 12", "same as". */
  change: string;
  /** "the 7 days before". */
  before: string;
  /** The two together: "up from 12 the 7 days before". */
  text: string;
  tone: CompareTone;
}

/** The period before, in words: "the day before", "the 7 days before". */
export function beforeWords(days: number): string {
  return days === 1 ? 'the day before' : `the ${days} days before`;
}

export interface CompareOptions {
  /** How many days the period holds (AdminPeriod.days). */
  days: number;
  format: (n: number) => string;
  /** Which way is good: up for sign-ups and money, down for problems and cost. */
  goodWhen?: 'up' | 'down' | undefined;
}

export function compare(current: number, previous: number, options: CompareOptions): Compared {
  const before = beforeWords(options.days);
  if (current === previous)
    return { change: 'same as', before, text: `same as ${before}`, tone: 'muted' };
  const up = current > previous;
  const change = `${up ? 'up' : 'down'} from ${options.format(previous)}`;
  const good = up === ((options.goodWhen ?? 'up') === 'up');
  return { change, before, text: `${change} ${before}`, tone: good ? 'success' : 'danger' };
}
